import React from 'react'
import Icon from 'antd/es/icon'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Grid from '@material-ui/core/Grid'
import { Link as RouterLink } from 'react-router-dom'
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline"
import DeleteIcon from "@material-ui/icons/Delete"
import IconButton from '@material-ui/core/IconButton'
 
// START - columns for tables with status filter
export const ColumnsForAllOrders = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Autorización',
            selector: 'cAndR',
            sortable: true,
            cell: row => row.cAndR
        },
        {
            name: 'VIN',
            selector: 'vin',
            sortable: true,
            width: '165px',
            cell: row => row.vin
        },
        {
            name: 'Fecha de creación',
            selector: 'creationDate',
            sortable: true,
            width: '160px'
        },
        {
            name: 'Sucursal',
            selector: 'sucursal',
            sortable: true,
            width: '250px',
            cell: row => row.sucursal
        },
        {
            name: 'Estatus de Factura',
            selector: 'invoiceStatus',
            width: '170px',
            sortable: true,
            cell: row => row.invoiceStatus
        },
        {
            name: 'Monto de factura',
            selector: 'invoiceAmount',
            sortable: true,
            cell: row => row.invoiceAmount
        },
        {
            name: 'Opciones',
            width: '310px',
            center: true,
            cell: row => (showButtonsAllOrders(row))
        }
    ]
)
 
const showButtonsAllOrders = (row) => {
    switch (row.invoiceStatus) {
        case 'Sin factura':
            return (
                <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadEvidence/${row.cAndR}`}>Subir evidencias</Button>
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadInvoice/${row.cAndR}`}>Subir factura</Button>
                </ButtonGroup>
            )
        case 'En revisión de pago':
            return (
                <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadEvidence/${row.cAndR}`}>Subir evidencias</Button>
                    <Button type="button" variant="outlined" disabled>Subir factura</Button>
                </ButtonGroup>
            )
        case 'Factura rechazada':
            return (
                <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadEvidence/${row.cAndR}`}>Subir evidencias</Button>
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadInvoice/${row.cAndR}`}>Subir factura</Button>
                </ButtonGroup>
            )
        case 'Pagada':
            if (row.statusCompErrorInv === "Pendiente") {
                return (
                    <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                        <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadComplement/${row.cAndR}`}>Subir Complemento</Button>
                    </ButtonGroup>
                )
            }
            break;
        case 'Pagada parcialmente':
            return (
                <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadEvidence/${row.cAndR}`}>Subir evidencias</Button>
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadInvoice/${row.cAndR}`}>Subir factura</Button>
                </ButtonGroup>
            )
        case 'Pagada cancelada por B2B':
            return (
                <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadEvidence/${row.cAndR}`}>Subir evidencias</Button>
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadInvoice/${row.cAndR}`}>Subir factura</Button>
                </ButtonGroup>
            )
        case 'Factura en espera de Comisión':
            return(
                <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadEvidence/${row.cAndR}`}>Subir evidencias</Button>
                    <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadInvoice/${row.cAndR}`}>Subir factura</Button>
                </ButtonGroup>
            )
        default:
            break;
    }
}
 
export const ColumnsForStatusWithOutInvoice = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Autorización',
            selector: 'cAndR',
            sortable: true,
            cell: row => row.cAndR
        },
        {
            name: 'VIN',
            selector: 'vin',
            sortable: true,
            width: '165px',
            cell: row => row.vin
        },
        {
            name: 'Fecha de creación',
            selector: 'creationDate',
            sortable: true,
            width: '160px'
        },
        {
            name: 'Sucursal',
            selector: 'sucursal',
            sortable: true,
            width: '250px',
            cell: row => row.sucursal
        },
        {
            name: 'Estatus de Factura',
            width: '160px',
            cell: row => (showTrafficLightsWithOutInvoice(row))
        },
        {
            name: 'Monto de factura',
            selector: 'invoiceAmount',
            sortable: true,
            cell: row => row.invoiceAmount
        },
        {
            name: 'Opciones',
            width: '310px',
            center: true,
            cell: row => (showButtonsWithOutInvoice(row))
        }
    ]
)
 
const showButtonsWithOutInvoice = (row) => {
    return (
        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
            <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadEvidence/${row.cAndR}`}>Subir evidencias</Button>
            <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadInvoice/${row.cAndR}`}>Subir factura</Button>
        </ButtonGroup>
    )
}
 
const showTrafficLightsWithOutInvoice = (row) => {
    switch (row.invoiceStatus) {
        case '+60 días':
            return (
                <Grid container item xs={12}>
                    <Grid item xs={4}>
                        <div style={circleStyleRed}></div>
                    </Grid>
                    <Grid item xs={8}>
                        <label>+ 60 días</label>
                    </Grid>
                </Grid>
            )
        case '60 días':
            return (
                <Grid container item xs={12}>
                    <Grid item xs={4}>
                        <div style={circleStyleRed}></div>
                    </Grid>
                    <Grid item xs={8}>
                        <label>60 días</label>
                    </Grid>
                </Grid>
            )
        case '45 días':
            return (
                <Grid container item xs={12}>
                    <Grid item xs={4}>
                        <div style={circleStyleYellow}></div>
                    </Grid>
                    <Grid item xs={8}>
                        <label>45 días</label>
                    </Grid>
                </Grid>
            )
        case '30 días':
            return (
                <Grid container item xs={12}>
                    <Grid item xs={4}>
                        <div style={circleStyleGreen}></div>
                    </Grid>
                    <Grid item xs={8}>
                        <label>30 días</label>
                    </Grid>
                </Grid>
            )
        default:
            return
    }
}
 
const circleStyleRed = {
    padding: 5,
    display: "inline-block",
    backgroundColor: "#DD231D",
    borderRadius: "100%",
    width: 25,
    height: 25,
}
const circleStyleGreen = {
    padding: 5,
    display: "inline-block",
    backgroundColor: "#2DCB09",
    borderRadius: "100%",
    width: 25,
    height: 25,
}
const circleStyleYellow = {
    padding: 5,
    display: "inline-block",
    backgroundColor: "#FAFA00",
    borderRadius: "100%",
    width: 25,
    height: 25,
}
 
export const ColumnsForStatusPaymentReview = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Autorización',
            selector: 'cAndR',
            sortable: true,
            cell: row => row.cAndR
        },
        {
            name: 'VIN',
            selector: 'vin',
            sortable: true,
            width: '165px',
            cell: row => row.vin
        },
        {
            name: 'Fecha de creación',
            selector: 'creationDate',
            sortable: true,
            width: '160px'
        },
        {
            name: 'Sucursal',
            selector: 'sucursal',
            sortable: true,
            width: '250px',
            cell: row => row.sucursal
        },
        {
            name: 'Estatus de Factura',
            selector: 'invoiceStatus',
            width: '170px',
            sortable: true,
            cell: row => row.invoiceStatus
        },
        {
            name: 'Monto de factura',
            selector: 'invoiceAmount',
            sortable: true,
            cell: row => row.invoiceAmount
        },
        {
            name: 'Opciones',
            width: '310px',
            center: true,
            cell: row => (showButtonsPaymentReview(row))
        }
    ]
)
 
const showButtonsPaymentReview = (row) => {
    return (
        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
            <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadEvidence/${row.cAndR}`}>Subir evidencias</Button>
            <Button type="button" disabled variant="outlined">Subir factura</Button>
        </ButtonGroup>
    )
}
 
export const ColumnsForStatusRejected = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '40px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Autorización',
            width: '100px',
            selector: 'cAndR',
            sortable: true,
            cell: row => row.cAndR
        },
        {
            name: 'VIN',
            width: '250px',
            selector: 'vin',
            sortable: true,
            cell: row => row.vin
        },
        {
            name: 'Fecha de creación',
            selector: 'creationDate',
            sortable: true,
            width: '160px'
        },
        {
            name: 'Sucursal',
            width: '250px',
            selector: 'sucursal',
            sortable: true,
            cell: row => row.sucursal
        },
        {
            name: 'Estatus de Factura',
            selector: 'invoiceStatus',
            width: '170px',
            sortable: true,
            cell: row => row.invoiceStatus
        },
        {
            name: 'Monto de factura',
            width: '110px',
            selector: 'invoiceAmount',
            sortable: true,
            cell: row => row.invoiceAmount
        }
    ]
)
 
const showButtonsStatusRejected = (row) => {
    return (
        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
            <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadEvidence/${row.cAndR}`}>Subir evidencias</Button>
            <Button type="button" variant="outlined" component={RouterLink} to={`/maintenance/UploadInvoice/${row.cAndR}`}>Subir factura</Button>
        </ButtonGroup>
    )
}
 
export const ColumnsForStatusPaymentProcess = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Autorización',
            selector: 'cAndR',
            sortable: true,
            cell: row => row.cAndR
        },
        {
            name: 'VIN',
            selector: 'vin',
            sortable: true,
            width: '250px',
            cell: row => row.vin
        },
        {
            name: 'Fecha de creación',
            selector: 'creationDate',
            sortable: true,
            width: '160px'
        },
        {
            name: 'Sucursal',
            selector: 'sucursal',
            sortable: true,
            width: '250px',
            cell: row => row.sucursal
        },
        {
            name: 'Estatus de Factura',
            selector: 'invoiceStatus',
            sortable: true,
            cell: row => row.invoiceStatus
        },
        {
            name: 'Monto de factura',
            selector: 'invoiceAmount',
            sortable: true,
            cell: row => row.invoiceAmount
        }
    ]
)
 
export const ColumnsForStatusPayed = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '35px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Autorización',
            width: '100px',
            selector: 'cAndR',
            sortable: true,
            cell: row => row.cAndR
        },
        {
            name: 'VIN',
            width: '250px',
            selector: 'vin',
            sortable: true,
            cell: row => row.vin
        },
        {
            name: 'Fecha de creación',
            width: '160px',
            selector: 'creationDate',
            sortable: true,
        },
        {
            name: 'Sucursal',
            selector: 'sucursal',
            sortable: true,
            width: '250px',
            cell: row => row.sucursal
        },
        {
            name: 'Estatus de Factura',
            width: '175px',
            selector: 'invoiceStatus',
            sortable: true,
            cell: row => row.invoiceStatus
        },
        {
            name: 'Monto de factura',
            width: '145px',
            selector: 'invoiceAmount',
            sortable: true,
            cell: row => row.invoiceAmount
        }
    ]
)
 
const showButtonsStatusPayed = (row) => {
    if (row.ordersStatusId === 22 || row.ordersStatusId === 30) {
        return (
            <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                <Button type="button" variant="outlined" style={{ textAlign: 'center' }} component={RouterLink} to={`/maintenance/UploadInvoice/${row.cAndR}`}>Subir factura</Button>
                <Button type="button" variant="outlined" style={{ textAlign: 'center' }} component={RouterLink} to={`/maintenance/UploadComplement/${row.cAndR}`}>Subir Complemento</Button>
            </ButtonGroup>
        )
    } else if (row.statusCompErrorInv === "Pendiente") {
        return (
            <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                <Button type="button" variant="outlined" style={{ textAlign: 'center' }} component={RouterLink} to={`/maintenance/UploadComplement/${row.cAndR}`}>Subir Complemento</Button>
            </ButtonGroup>
        )
    } else {
        return ("")
    }
}
 
// START - columns for tables with upload evidence
 
export const ColumnsForUploadEvidenceUnitPhotos = ({ showButtonDeleteAux }) => (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Fotos',
            selector: 'nameEvidence',
            sortable: true,
            width: '400px',
            cell: row => row.nameEvidence
        },
        {
            name: 'Fecha',
            selector: 'date',
            sortable: true,
            width: '170px',
            cell: row => row.date
        },
        {
            name: 'Opciones',
            center: true,
            width: '120px',
            cell: row => (showButtonDelete(row, { showButtonDeleteAux }))
        }
    ]
)
 
export const ColumnsForUploadEvidenceDocumentPhoto = ({ showButtonDeleteAux }) => (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Fotos',
            selector: 'nameEvidence',
            sortable: true,
            width: '400px',
            cell: row => row.nameEvidence
        },
        {
            name: 'Fecha',
            selector: 'date',
            sortable: true,
            width: '170px',
            cell: row => row.date
        },
        {
            name: 'Opciones',
            center: true,
            width: '120px',
            cell: row => (showButtonDelete(row, { showButtonDeleteAux }))
        }
    ]
)
 
export const ColumnsForUploadEvidenceVideo = ({ showButtonDeleteAux }) => (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Videos',
            selector: 'nameEvidence',
            sortable: true,
            width: '400px',
            cell: row => row.nameEvidence
        },
        {
            name: 'Fecha',
            selector: 'date',
            sortable: true,
            width: '170px',
            cell: row => row.date
        },
        {
            name: 'Opciones',
            center: true,
            width: '120px',
            cell: row => (showButtonDelete(row, { showButtonDeleteAux }))
        }
    ]
)
 
const showButtonDelete = (row, { showButtonDeleteAux }) => {
    return (
        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
            <Button type="button" variant="outlined" onClick={() => showButtonDeleteAux(row.idEvidence)}>Eliminar</Button>
        </ButtonGroup>
    )
}
 
//column for historical table
export const ColumnsForInvoiceHistorical = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '40px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Factura',
            selector: 'nameInvoice',
            sortable: true,
            cell: row => row.nameInvoice
        },
        {
            name: 'Fecha',
            width: '200px',
            selector: 'date',
            sortable: true,
            cell: row => row.date
        },
        {
            name: 'Mensaje',
            selector: 'message',
            sortable: true,
            width: '300px',
            cell: row => row.message
        }
    ]
)
 
//column for InvoiceComplement
export const ColumnsForInvoiceComplement = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Factura',
            selector: 'nameInvoice',
            sortable: true,
            width: '320px',
            cell: row => row.nameInvoice
        },
        {
            name: 'Monto de la factura',
            selector: 'totalAmount',
            sortable: true,
            width: '130px',
            cell: row => row.totalAmount
        },
        {
            name: 'Complementos cargados',
            selector: 'complements',
            sortable: true,
            width: '150px',
            cell: row => showComplementList(row.complements)
        },
        {
            name: 'Complemento',
            selector: 'statusComplement',
            sortable: true,
            width: '130px',
            center: true,
            cell: row => (showIconProcessFinished(row))
        }
    ]
)
const showComplementList = (complements) => {
    return (
        <div>
            {
                complements && (
                    complements.map((item, index) => {
                        return (
                            <Grid item xs={12} key={index}>
                                <Grid container item xs={12}>
                                    <Grid item xs={12}>
                                        {item.amountPaid}
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    }
                    )
                )
            }
 
        </div>
    )
}
 
const showIconProcessFinished = (row) => {
    if (row.statusComplement) {
        return (
            <Grid container item xs={12} style={{ textAlign: 'center' }}>
                <Grid item xs={12}>
                    <CheckCircleIcon style={{ color: 'green', fontSize: "1rem" }} />
                </Grid>
            </Grid>
        )
    } else {
        return (
            <Grid container item xs={12} style={{ textAlign: 'center' }}>
                <Grid item xs={12}>
                    <ErrorOutlineIcon style={{ color: '#FFAB00', fontSize: "1rem" }} />
                </Grid>
            </Grid>
        )
    }
}
 
//column for RejectedInvoces
export const ColumnsForRejectesInvoice = ({ DeleteRejectedInvoice }) => (
    [
        {
            name: 'Eliminar',
            width: '90px',
            center: true,
            cell: row => (showButtonDeleteRejectesInvoice(row, { DeleteRejectedInvoice }))
        },
        {
            name: 'Folio',
            selector: 'folio',
            sortable: true,
            cell: row => row.folio
        }
    ]
)
 
const showButtonDeleteRejectesInvoice = (row, { DeleteRejectedInvoice }) => {
    return (
        <IconButton aria-label="delete" style={{ color: '#C22727' }} title="Eliminar" onClick={() => DeleteRejectedInvoice(row.idInvoice)}>
            <DeleteIcon />
        </IconButton>
    )
}